import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface MemberItemProps {
  /** Avatar element */
  readonly avatar: ReactNode;
  /** Name to display */
  readonly name: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A compact row with an avatar and a name. Used in team member lists.
 */
export function MemberItem({ avatar, name, className }: MemberItemProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      {avatar}
      <span className="text-sm text-content">{name}</span>
    </div>
  );
}
